import { render, staticRenderFns } from "./noaccess-page.vue?vue&type=template&id=20540ad6&scoped=true"
import script from "./noaccess-page.vue?vue&type=script&lang=js"
export * from "./noaccess-page.vue?vue&type=script&lang=js"
import style0 from "./noaccess-page.vue?vue&type=style&index=0&id=20540ad6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20540ad6",
  null
  
)

export default component.exports